"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LuxonDateTimeFormatStringRegex = exports.Reporting = exports.DayIterable = void 0;
exports.DayIterable = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
];
var Reporting;
(function (Reporting) {
    // all resolved start and end dates are inclusive
    Reporting.PeriodIterable = [
        // resolves to start=reportingDate; end=reportingDate
        // reportingDate 2023-10-23 => start: 2023-10-23; end: 2023-10-23;
        'calendarDay',
        // resolves to start=1st day of calendar week; end=last day of calendar week
        // optional weekStartDay parameter to set start day of week, defaults to Monday
        // reportingDate 2023-10-24 (Tuesday) => start: 2023-10-23 (Monday); end: 2023-10-29 (Sunday);
        'calendarWeek',
        // resolves to start=1st day of calendar month; end=last day of calendar month
        // reportingDate 2023-01-16 => start: 2023-01-01; end: 2023-01-31;
        'calendarMonth',
        // resolves to start=1st day of calendar quarter; end=last day of calendar quarter
        // calendar quarters: Q1=1/1-3/31; Q2=4/1-6/30; Q3=7/1-9/30; Q4=10/1-12/31
        // reportingDate 2023-01-16 => start: 2023-01-01; end: 2023-03-31;
        'calendarQuarter',
        // resolves to start=1st day of calendar year; end=last day of calendar year
        // calendar year: 1/1-12/31
        // reportingDate 2023-01-16 => start: 2023-01-01; end: 2023-12-31;
        'calendarYear',
    ];
    // we construct ReportingPeriod data structure from encoded formula engine string
    // for use within LoanTapeMetadata framework. When adding new reportingPeriod properties
    // please update this const and LoanTapeMetadata framework.
    Reporting.AllReportingPeriodPropertiesIterable = [
        'period',
        'weekStartDay',
    ];
})(Reporting = exports.Reporting || (exports.Reporting = {}));
exports.LuxonDateTimeFormatStringRegex = /^(?:\s|'.*'|\W)*(?:S|SSS|u|uu|uuu|s|ss|m|mm|h|hh|H|HH|Z|ZZ|ZZZ|ZZZZ|ZZZZZ|z|a|d|dd|c|ccc|cccc|ccccc|L|M|LL|MM|LLL|MMM|LLLL|MMMM|LLLLL|MMMMM|y|yy|yyyy|G|GG|GGGGG|kk|kkkk|W|WW|o|ooo|q|qq|D|DD|DDD|DDDD|t|tt|ttt|tttt|T|TT|TTT|TTTT|f|ff|fff|ffff|F|FF|FFF|FFFF|X|x)+(?:S|SSS|u|uu|uuu|s|ss|m|mm|h|hh|H|HH|Z|ZZ|ZZZ|ZZZZ|ZZZZZ|z|a|d|dd|c|ccc|cccc|ccccc|L|M|LL|MM|LLL|MMM|LLLL|MMMM|LLLLL|MMMMM|y|yy|yyyy|G|GG|GGGGG|kk|kkkk|W|WW|o|ooo|q|qq|D|DD|DDD|DDDD|t|tt|ttt|tttt|T|TT|TTT|TTTT|f|ff|fff|ffff|F|FF|FFF|FFFF|X|x|\s|'.*'|\W)*$/;
//# sourceMappingURL=Date.js.map